import store from '@/store';

export default (to, from, next) => ({
  allow: store.getters.is_account_suspended,
  redirect: { name: store.getters.is_account_suspended ? 'suspended' : 'home' },
});
